import Backbone from 'backbone'
import template from './datasets-date-filter-step1.hbs'
import selects from 'scoreboard/components/selects'
import calendars from 'scoreboard/components/calendars'
import _ from 'lodash'
import arrayToHash from 'scoreboard/components/array-to-hash'
import i18n from 'scoreboard/components/i18n'
import monthsOfTheYear from 'scoreboard/components/months-of-the-year'
import daysOfTheWeek from 'scoreboard/components/days-of-the-week'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import EquationAndDateMultiSelector from './equation-and-date-multi-selector'
import DateTimeMultiSelector from 'scoreboard/components/date-time-multi-selector'
import { timeToSplitFieldsObject } from 'scoreboard/components/date-time-util'
import breakdownPeriodOptions from 'scoreboard/components/designer/breakdown-period-options'
import momentHelper from 'scoreboard/components/moment-helper'

function renderPeriodIdsSelect(selector, periodIds, calendarId) {
	const periodIdsHash = periodIds ? arrayToHash(periodIds) : {}
	let periods = _.values(calendars.periodsById)
	if (!_.isNil(calendarId)) {
		const calendar = calendars.calendarsById[calendarId]
		if (!_.isNil(calendar)) {
			periods = calendar.periods
		}
	}

	let options = _.map(periods, (period) => {
		return {
			value: period.id,
			label: period.label,
			selected: periodIdsHash[period.id]
		}
	})

	selects.filtering(selector, {
		multiple: true,
		options: options
	})
}

/**
 * Extra controls that may appear for date filters in filter-step1, depending
 * on the operator (aka filter type)
 */
var DatasetsDateFilterStep1 = Backbone.View.extend({

	/** @type {Dataset} */
	model: null,

	// this.options.filter is the filter we're working with
	// this.options.new indicates if this is a new filter
	// this.options.wizard is the wizard
	// this.options.FormView {FormView} the FormView

	initialize: function(options) {
		this.options = options || {}
		this.markedFields = []
		// when toggling whether the field is in an or group, need to reposition
		// any tooltips that are displayed
		this.options.formView?.on('change', () =>
			_.invokeMap(this.markedFields, 'repositionTooltip'))
	},

	events: {
		'change [name=fieldIdentifier]': 'clearErrors',
		'change [name=operator]': 'changeOperator',
		'click .times-label': 'preventLabelClick'
	},

	render: function() {
		this.$('.datasets-date-filter').empty().append(template())

		renderPeriodIdsSelect(this.$('[name=periodIds]'),
			this.options.filter.periodIds)
		this.renderPeriodIndexesSelect()
		this.renderDatesSelect()
		this.renderTimesSelect()
		this.renderEnumSelect('days')
		this.renderEnumSelect('months')
		// make sure the display is correct for the current operator
		this.changeOperator()
		return this
	},


	// Prevents focusing the label when clicking on the input. This allows
	// the date-time inputs to be focused immediately.
	preventLabelClick: function(e) {
		e.preventDefault()
	},

	renderDatesSelect() {
		this.equationAndDateMultiSelector = new EquationAndDateMultiSelector({
			el: this.$('[name=dates]'),
			dates: this.options.filter.dates,
			equations: this.options.filter.equations,
			required: !this.options.allowIncomplete
		}).render()
		this.equationAndDateMultiSelector.on('edit-equation',
			equation => this.trigger('edit-equation', equation))
	},

	renderTimesSelect() {
		const timeDisplayType = _.result(this.options, 'field.timeDisplayType')
		const hr24 = momentHelper.is24hrTimeType(timeDisplayType)
		const times = (this.options.filter.times || [])
			.map(it => timeToSplitFieldsObject(it, hr24))
		this.timesMultiSelector = new DateTimeMultiSelector({
			el: this.$('[name=times]'),
			times,
			required: !this.options.allowIncomplete,
			timeDisplayType
		}).render()
	},

	/**
	 * Renders the "Days of the Week" or "Months of the Year" select, depending
	 * on the value for the name parameter.
	 *
	 * @param name 'days' or 'months'
	 */
	renderEnumSelect: function(name) {
		var hash = arrayToHash(this.options.filter[name])
		let enumeration = name === 'days' ? daysOfTheWeek() : monthsOfTheYear()
		let options = _.map(enumeration, (label, value) => {
			return {
				value,
				label: _.escape(label),
				selected: hash[value]
			}
		})
		selects.filtering(this.$(`[name=${name}]`), {
			multiple: true,
			options: options,
			sort:[]
		})
		this.markedFields.push(new MarkedField({
			el: this.$(`[name=${name}]`),
			validator: this.options.allowIncomplete ? null : requiredValidator
		}).render())
	},

	renderPeriodIndexesSelect: function () {
		let filter = this.options.filter

		let options = []
		if (filter.groupCalendarId && filter.breakdownCalendarId) {
			let selectedIndexes = _.map(filter.periodIndexes, i => parseInt(i))
			options = breakdownPeriodOptions(_.pick(filter, 'groupCalendarId', 'breakdownCalendarId'))
				.map(opt => {
					return {
						value: opt.id,
						label: opt.label,
						selected: _.includes(selectedIndexes, opt.id)
					}
				})
		}

		selects.filtering(this.$('[name=periodIndexes]'), {
			multiple: true,
			options: options
		})
	},

	// returns the current operator
	operator: function () {
		return this.$('[name=operator]').val()
	},

	changeOperator: function() {
		let operator = this.operator()

		const inAnyPeriodOrIsPeriod = 'in-any-period' === operator || 'is-period' === operator
		this.$('.period-label').toggleClass('is-not-displayed', !inAnyPeriodOrIsPeriod)

		let inAnyPeriodIndex = 'in-any-period-index' === operator
		this.$('.period-index-label').toggleClass('is-not-displayed', !inAnyPeriodIndex)

		let onAnyDate = 'on-any-date' === operator
		this.$('.dates-label, .add-equation').toggleClass('is-not-displayed', !onAnyDate)

		let atAnyTime = 'at-any-time' === operator
		this.$('.times-label').toggleClass('is-not-displayed', !atAnyTime)

		let days = 'on-day-of-the-week' === operator
		this.$('.days-label').toggleClass('is-not-displayed', !days)

		let months = 'in-month-of-the-year' === operator
		this.$('.months-label').toggleClass('is-not-displayed', !months)

		// whether an extra control needs to be displayed
		let extraControl = inAnyPeriodOrIsPeriod || onAnyDate || atAnyTime || days || months || inAnyPeriodIndex
		this.$('.datasets-date-filter').toggleClass('is-not-displayed', !extraControl)

		this.clearErrors()
	},

	onEquationChanged: function(oldEquation, equation) {
		let index = _.findIndex(this.equationAndDateMultiSelector.selectOptions,
			option => option.value == oldEquation)
		let options = this.equationAndDateMultiSelector.selectOptions || []
		let newOption = {
			label: _.escape(equation),
			value: equation,
			selected: true,
			dataset: {
				type: 'equation'
			}
		}
		if (index == -1) {
			options.push(newOption)
		} else {
			options.splice(index, 1, newOption)
		}
		this.equationAndDateMultiSelector.selectOptions = options
		this.equationAndDateMultiSelector.renderSelect()
	},

	clearErrors: function() {
		_.invokeMap(this.markedFields, 'clearError')
	},

	test: function() {
		if (this.options.allowIncomplete) {
			return
		}

		let op = this.operator()
		if ((op === 'in-any' || op === 'in-any-period' || op === 'is-period') &&
			_.isEmpty(this.$('[name=periodIds]').val())) {
			return i18n.get('datasets.filters.date.periods.required')
		}
		if (op === 'in-month-of-the-year' &&
			_.isEmpty(this.$('[name=months]').val())) {
			return i18n.get('datasets.filters.date.months.required')
		}
		if (op === 'on-day-of-the-week' &&
			_.isEmpty(this.$('[name=days]').val())) {
			return i18n.get('datasets.filters.date.days.required')
		}

		if (op === 'on-any-date' &&
			_.isEmpty(this.$('[name=dates]').val())) {
			return i18n.get('datasets.filters.date.dates.required')
		}

		if (op === 'at-any-time' &&
			_.isEmpty(this.$('[name=times]').val())) {
			return i18n.get('datasets.filters.date.times.required')
		}
	},

	cleanup: function() {
		this.clearErrors()
		_.invoke(this.equationAndDateMultiSelector, 'cleanup')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([...this.markedFields, this.equationAndDateMultiSelector], 'remove')
	}

})

export default DatasetsDateFilterStep1
export { renderPeriodIdsSelect }

DatasetsDateFilterStep1.__filename__ = 'datasets/filters/datasets-date-filter-step1.js'
